/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTypeOptionsSpec } from './rolloutTypeOptionsSpec';


/**
 * Rollout types and supported options spec, to be looked up when saving a plan for a rollout type.
 */
export interface RolloutPlanOptionsSpecResponse { 
    /**
     * List of rollout types, each with supported options spec.
     */
    rollout_types_options_spec: Array<RolloutTypeOptionsSpec>;
}

